import type { Locale } from '../../shared/locale';
import type { ViewMode } from '../../types';
import { $appConfig, jsonReplacer, type AppConfig } from '../../state/appConfig';
import { $locale } from '../../state/locale';
import { $viewMode } from '../../state/viewMode';

/** The copy is meant to be pasted and shared, so the assistant token stays out. */
export const appConfigSnapshot = (config: AppConfig, viewMode: ViewMode, locale: Locale) => {
  const { assistantApiToken: _token, ...dev } = config.dev;
  return { ...config, dev, viewMode, locale };
};

/** "Copy App Config" (legacy AppConfigPanel parity): clipboard and console. */
export const copyAppConfig = (): void => {
  const snapshot = appConfigSnapshot(
    $appConfig.getState(),
    $viewMode.getState(),
    $locale.getState(),
  );
  const json = JSON.stringify(snapshot, jsonReplacer, 2);
  navigator.clipboard?.writeText(json);
  // eslint-disable-next-line no-console -- dev panel output, for when the clipboard is refused
  console.log(`[SplatDevPanel] App config:\n${json}`);
};
